import { Injectable } from '@angular/core';
import { PaymentApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { PaymentAction } from '../actions';
import { FnWithCompany, WithCompany } from '@cms/backgrounds/switch-company';

@Injectable()
export class PaymentEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(PaymentAction.loadItem),
      exhaustMap(action => {
        return this.fetch(action.id).pipe(map(item => PaymentAction.loadItemSuccess({ item })));
      })
    );
  });

  @FnWithCompany()
  fetch(id: number, @WithCompany() option: Record<string, any> = {}) {
    return this._apiService.get(id, option);
  }

  constructor(private _apiService: PaymentApiService, private _actions$: Actions, private _store: Store) {}
}
